/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OnlinePaymentConfig = {
    onlineProviderType: OnlinePaymentConfig.onlineProviderType;
};
export namespace OnlinePaymentConfig {
    export enum onlineProviderType {
        PAYPAL = 'paypal',
        STRIPE = 'stripe',
    }
}

